import { useMutation } from '@tanstack/react-query';

import useImperativeRequestWrapper from '@/hooks/useImperativeRequestWrapper';
import { MutationConfig } from '@/lib/react-query';

interface ICancelOtaPayload {
  lpUI: string;
}

const cancelOtaMutation =
  (makeRequest: ReturnType<typeof useImperativeRequestWrapper>[1]) =>
  async ({ lpUI }: ICancelOtaPayload): Promise<void> => {
    const { error } = await makeRequest({
      path: `/products/${lpUI}/ota/actions/cancel`,
      method: 'post',
    });

    if (error) {
      throw new Error(error?.response?.data?.message ?? error);
    }
  };

type UseCancelOtaOptions = {
  config?: MutationConfig<ReturnType<typeof cancelOtaMutation>>;
};

export const useCancelOta = ({ config }: UseCancelOtaOptions = {}) => {
  const [, makeRequest] = useImperativeRequestWrapper('deviceV3');

  return useMutation({
    ...config,
    mutationFn: cancelOtaMutation(makeRequest),
  });
};
